import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSnack } from 'base/core/selectors';
import { CoreSliceActions } from 'base/core/slice';
import { PrimarySnackbar } from 'components/molecules';

export default function CoreErrorAlert() {
  const dispatch = useDispatch();
  const { open, message, success } = useSelector(selectSnack);
  const handleClose = () => {
    dispatch(CoreSliceActions.closeSnackbar());
  };

  React.useEffect(() => {
    if (open) {
      setTimeout(() => {
        handleClose();
      }, 5000);
    }
  }, [open]);

  return (
    <PrimarySnackbar open={open} message={message} severity={success ? 'success' : 'error'} handleClose={handleClose} />
  );
}
